import endpoints from "@/api/endpoints";
import httpClient from "@/api/http-client";
import { FilterCategory } from "@/models/category";

const sameName = (a: any, b: any) =>
  String(a ?? "").trim().toLowerCase() === String(b ?? "").trim().toLowerCase();

// Breadth-first, so a direct child wins over a same-named deeper descendant.
const findInTree = (
  nodes: FilterCategory[],
  name: string
): FilterCategory | undefined => {
  let level = nodes || [];
  while (level.length) {
    const hit = level.find((n) => sameName(n.name ?? n.title, name));
    if (hit) return hit;
    level = level.flatMap((n) => n.children || []);
  }
  return undefined;
};

// Resolves the slug of the facet the user picked, scoped to the category currently
// being viewed (parentId) so same-named categories under other parents are ignored.
// Categories with no parent/children context fall back to the by-name lookup.
export const resolveCategorySlug = async (
  catName: string,
  parentId?: number
): Promise<string | undefined> => {
  if (parentId) {
    try {
      const { data } = await httpClient.get(endpoints.products.filters(parentId));
      const tree: FilterCategory[] = Array.isArray(data)
        ? data
        : data?.categories || [];
      const match = findInTree(tree, catName);
      if (match?.slug) return match.slug;
    } catch (error) {}
  }

  const { data } = await httpClient.get(
    endpoints.products.categorySlugbyName(catName)
  );
  return data?.slug;
};
